var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSendMeterReading = function SvgSendMeterReading(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M60 10.5898H43.3333V17.2565H60V10.5898Z",
    fill: "#0D8426"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M55 17.2565H48.3333V22.2565H55V17.2565Z",
    fill: "#0D8426"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.8333 62.2565H13.3333V68.9232H30.3333C28.1666 66.9232 26.3333 64.7565 24.8333 62.2565Z",
    fill: "#0D8426"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3.33333 48.9232V55.5898H21.6667C21 53.4232 20.5 51.2565 20.1667 48.9232H3.33333Z",
    fill: "#0D8426"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10 35.5898V42.2565H20.1667C20.3333 39.9232 21 37.7565 21.6667 35.5898H10Z",
    fill: "#0D8426"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6667 20.5898C37.8333 20.5898 26.6667 31.7565 26.6667 45.5898C26.6667 59.4232 37.8333 70.5898 51.6667 70.5898C65.5 70.5898 76.6667 59.4232 76.6667 45.5898C76.6667 31.7565 65.5 20.5898 51.6667 20.5898ZM55 45.5898H48.3333V28.9232H55V45.5898Z",
    fill: "#0D8426"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M73.3479 20.5181L58.9146 28.8514L62.2479 34.6247L76.6812 26.2914L73.3479 20.5181Z",
    fill: "#0D8426"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSendMeterReading);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "send-meter-reading.b6bdec39f574c3df69300863e5dd9a4e.svg";